
import barba from '@barba/core';

export default class{

    constructor(){

        barba.hooks.afterOnce((data) => {
            this.init()
        })
        barba.hooks.after((data) => {

            this.init()
        });
    }
    init (){
        const el = document.querySelector('[data-copyright-year]')
        if(el){
            const now =  new Date()
            let start = el.getAttribute('data-copyright-year')
            if(now.getFullYear() != start){
                start = start + '-' + now.getFullYear()
            }
            el.innerText = start
        }
    }
}